'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Link = require('react-router/lib/Link');

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Use createClass instead of ES6 class as Babel spews out a ton of code
// for polyfilling classes which there's no reason to pay for this.
// A function component would be ideal but we need componentDidMount.
var GatsbyLink = _react2.default.createClass({
  displayName: 'GatsbyLink',

  propTypes: {
    to: _react2.default.PropTypes.string.isRequired
  },

  componentDidMount: function componentDidMount() {
    var _this = this;

    // Only enable prefetching of Link resources in production and for browsers that
    // don't support service workers *cough* Safari/IE *cough*.
    if (process.env.NODE_ENV === 'production' && !('serviceWorker' in navigator)) {
      (function () {
        var routes = window.gatsbyRootRoute;

        var _require = require('history'),
            createMemoryHistory = _require.createMemoryHistory;

        var matchRoutes = require('react-router/lib/matchRoutes');
        var getComponents = require('react-router/lib/getComponents');

        var createLocation = createMemoryHistory().createLocation;

        if (typeof routes !== 'undefined') {
          matchRoutes([routes], createLocation(_this.props.to), function (error, nextState) {
            getComponents(nextState, function () {
              return console.log('loaded assets for ' + _this.props.to);
            });
          });
        }
      })();
    }
  },
  render: function render() {
    return _react2.default.createElement(_Link2.default, this.props);
  }
});

module.exports = GatsbyLink;


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-link/index.js
// module id = ./node_modules/gatsby-link/index.js
// module chunks = 1